import React from 'react';
import DashboardPage from '../pages/DashboardPage';
import ClientiPage from '../pages/ClientiPage';
import PraticaHubPage from '../pages/PraticaHubPage';
import PrezzarioPage from '../pages/PrezzarioPage';
import PreventiviPage from '../pages/PreventiviPage';
import ContiPage from '../pages/ContiPage';
import CantieriPage from '../pages/CantieriPage';
import ComputiPage from '../pages/ComputiPage';
import ListinoPage from '../pages/ListinoPage';
import FormazioneAIPage from '../pages/FormazioneAIPage';
import AdminPage from '../pages/AdminPage';
import ContabilitaPage from '../pages/ContabilitaPage';
import FornitoriPage from '../pages/FornitoriPage';
import ArchivioPage from '../pages/ArchivioPage';
import LeadPage from '../pages/LeadPage';

function isAdmin(user) {
  return user?.ruolo === 'admin' || user?.email === 'admin@edilcima.it';
}

export default function PageRouter({ page, pageContext, user, onNavigate }) {
  switch (page) {
    case 'dashboard': return <DashboardPage onNavigate={onNavigate} />;
    case 'clienti': return <ClientiPage onNavigate={onNavigate} />;
    case 'pratiche': return <PraticaHubPage onNavigate={onNavigate} />;
    case 'prezzario': return <PrezzarioPage />;
    case 'computi': return <ComputiPage onNavigate={onNavigate} />;
    case 'preventivi': return <PreventiviPage context={pageContext} />;
    case 'conti': return <ContiPage onNavigate={onNavigate} />;
    case 'cantieri': return <CantieriPage />;
    case 'listino': return <ListinoPage />;
    case 'archivio': return <ArchivioPage />;
    case 'lead': return <LeadPage onNavigate={onNavigate} />;
    case 'formazione': return <FormazioneAIPage />;
    case 'contabilita': return <ContabilitaPage />;
    case 'fornitori': return <FornitoriPage />;
    case 'admin': return isAdmin(user) ? <AdminPage /> : <DashboardPage onNavigate={onNavigate} />;
    default: return <DashboardPage onNavigate={onNavigate} />;
  }
}
